import Pressable from '@/components/motion/pressable';
import type { IUserDomain } from '@/entities/domain.entity';
import { ROUTES } from '@/app/routes';
import { BoxIcon, ChevronRightIcon, GlobeIcon } from 'lucide-react';
import { useNavigate } from 'react-router';
import DomainStatusBadge from './domain-status-badge';

interface DomainCardProps {
	domain: IUserDomain;
}

export default function DomainCard({ domain }: DomainCardProps) {
	const navigate = useNavigate();

	function openDetail() {
		navigate(`${ROUTES.apkDomain}${domain.id}`);
	}

	return (
		<Pressable
			role='button'
			tabIndex={0}
			className='rounded-xl border border-border bg-card p-3 shadow-sm text-left active:bg-accent/30 cursor-pointer'
			onClick={openDetail}
			onKeyDown={e => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					openDetail();
				}
			}}
		>
			<div className='flex items-start justify-between gap-2'>
				<div className='min-w-0 flex-1'>
					<div className='flex items-center gap-2'>
						<GlobeIcon size={16} className='shrink-0 text-muted-foreground' />
						<p className='truncate font-medium'>{domain.hostname}</p>
					</div>
					{domain.errorMessage ? (
						<p className='mt-1 text-xs text-destructive line-clamp-2'>{domain.errorMessage}</p>
					) : null}
				</div>
				<DomainStatusBadge status={domain.status} />
			</div>

			{domain.blockCheckResult ? (
				<p className='mt-2 text-xs text-muted-foreground'>
					Снаружи:{' '}
					<span className={domain.blockCheckResult.reachable ? 'text-chart-2' : 'text-destructive'}>
						{domain.blockCheckResult.reachable ? 'доступен' : 'недоступен'}
					</span>
				</p>
			) : null}

			<div className='mt-3 flex items-center justify-between gap-2 border-t border-border/60 pt-3'>
				<div className='flex items-center gap-3 text-xs text-muted-foreground'>
					<span className='inline-flex items-center gap-1.5'>
						<BoxIcon size={12} />
						<span>{domain.buildsCount ?? 0} сборок</span>
					</span>
					<span>{domain.launchCount} установок</span>
				</div>

				<ChevronRightIcon size={16} className='text-muted-foreground' />
			</div>
		</Pressable>
	);
}
